import { FC } from 'react'

import { Cookie } from './utils/cookie-settings'

type CookiesBoxProps = {
  title: string
  description: string
  cookies?: Cookie[]
}

export const CookiesBox: FC<CookiesBoxProps> = ({
  // eslint-disable-next-line unused-imports/no-unused-vars
  cookies,
  title,
  description,
  children,
}) => {
  return (
    <div className="flex flex-col space-y-4">
      <div className="flex justify-between">
        <h4 className="text-content">{title}</h4>
        {children}
      </div>
      <div className="bg-surface-subdued text-content-subdued p-4">
        {description}
      </div>
    </div>
  )
}
